// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SlidersOutlinedSvg from "@ant-design/icons-svg/es/asn/SlidersOutlined";
import AntdIcon from '../components/AntdIcon';

var SlidersOutlined = function SlidersOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SlidersOutlinedSvg
  }));
};

SlidersOutlined.displayName = 'SlidersOutlined';
export default React.forwardRef(SlidersOutlined);